// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Books: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 42 42" enableBackground="new 0 0 42 42" xmlSpace="preserve">
<g>
	<path d="M4.33,8.5H0.17v29.17c0,2.29,1.88,4.17,4.17,4.17H33.5v-4.17H4.33V8.5z"/>
	<path d="M37.67,0.17h-25c-2.29,0-4.17,1.88-4.17,4.17v25c0,2.29,1.88,4.17,4.17,4.17h25c2.29,0,4.17-1.88,4.17-4.17v-25
		C41.83,2.04,39.96,0.17,37.67,0.17z M27.25,27.25h-12.5v-4.17h12.5V27.25z M35.58,18.92H14.75v-4.17h20.83V18.92z M35.58,10.58
		H14.75V6.42h20.83V10.58z"/>
</g>
</svg>;
};

export default React.memo(Books);
